import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-section-hero-static',
  templateUrl: './section-hero-static.component.html',
  styleUrls: ['./section-hero-static.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionHeroStaticComponent {

  @Input() darkMode: boolean = false;
  @Input() scrollToId: string;
  @Input() contactAvailable: boolean = false;

  @Output() scrollToElement: EventEmitter<string> = new EventEmitter();

  constructor() { }

  shouldScrollToElement(elementId: string) {
    this.scrollToElement.emit(elementId);
  }
}
